import { type BracketGameData } from '@terros/common'

export const getBracketGameEndDate = (game: Pick<BracketGameData, 'rounds' | 'startDate'>): number => {
  return game.rounds.reduce((acc, round) => {
    return Math.max(acc, round.endDate)
  }, game.startDate)
}
